import * as React from 'react';
const CopyRight = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={21}
    height={20}
    fill="none"
    viewBox="0 0 21 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      d="M16.614 10.938V5a2.5 2.5 0 0 0-2.5-2.5H8.177m3.437 15H5.99a1.875 1.875 0 0 1-1.875-1.875V7.5c0-1.035.84-1.875 1.875-1.875h5.625c1.036 0 1.875.84 1.875 1.875v8.125c0 1.036-.84 1.875-1.875 1.875Z"
    />
  </svg>
);
export default CopyRight;
